import gql from 'graphql-tag';

export class UniversalLinkMutations {
  static identifyRecipient = gql`
    mutation IdentifyRecipient(
      $gdprConsent: Boolean
      $documentId: String!
      $email: String!
      $firstName: String
      $lastName: String
      $title: String
      $companyName: String
    ) {
      identifyRecipient(
        gdprConsent: $gdprConsent
        documentId: $documentId
        email: $email
        firstName: $firstName
        lastName: $lastName
        title: $title
        companyName: $companyName
      ) {
        url
      }
    }
  `;
}
